module.exports = __webpack_public_path__ + "img/hourglass.5eaf2f36.png";